import React, { Component } from "react";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { HeaderFilter } from "../../../common/header-filter/header-filter.component";
import { DataTable } from "../../../common/table/data-table/data-table-component";
import { httpGet } from "../../../../utils/api.utils";
import { ACCOUNT_TABLE_HEADERS } from "../../../../utils/constant.utils"
import AccountDetails from "./details/account.details.component";
import { Header_Filter_Button_Label } from "../../../../constants/internal-constants";

export class Account extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1,
            totalEntries: 0,
            viewDetailPage: false,
            accountDataItem: [],
            requestDetails: false,
        }
    }
    componentDidMount() {
        this.getCatalogueDetails(this.state.pageNumber);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.pageNumber !== this.state.pageNumber) {
            this.setState({ requestDetails: false })
            this.getCatalogueDetails(this.state.pageNumber);
        }

    }
    updatePageNumber = (page) => {
        this.setState({ pageNumber: page })
    }
    getCatalogueDetails = async (pageNumber) => {
        this.setState({ activePage: pageNumber });
        var that = this;
        const dealName = window.sessionStorage.getItem('DealName')
        const getAccountData = await httpGet(`internal/Account/getAllAccounts`)
        var userID = window.sessionStorage.getItem("UserID");
        const newAccountData = getAccountData?.slice(0, 20)?.map((item) => (
            {
                AccountNumber: item.AccountNumber,
                SubAcct_Number: item.SubAcct_Number,
                AccountTypeName: item.AccountTypeName,
                VendorName: item.VendorName,
                AccountStatusName: item.AccountStatusName
            }))

        this.setState({ accountDataItem: [...newAccountData] });
        if (this.state.accountDataItem.length > 0) {
            this.setState({ requestDetails: true, totalEntries: 0 })
        }
    }
    getData=(value)=>{
		this.setState({viewDetailPage:value})
	  }
    render() {
        const dropdownItem = ["Item 1", "Item 2", "Item 3"]
        const dataTable = [
            {
                HeaderItem: ACCOUNT_TABLE_HEADERS,
                dataItem: this.state.accountDataItem

            }
        ]
        const pages = {
            HasNext: true,
            HasPrevious: false,
            PageNumber: 0,
            PerPage: 21,
            TotalEntries: 2453,
            TotalPages: 123

        }
        const listItem = [
            {
                listTitle: "Plan",
                href: "#"
            }
            , {
                listTitle: "Feature"
                , href: "#"
            }
            , {
                listTitle: "Rate"
                , href: "#"
            }
        ];
        
        return (
            <>
                <RequestHeaders headerTitle="Account" />
                {this.state.viewDetailPage ? 
                    <AccountDetails closeForm={this.getData.bind(this)}/>
                :
                    <div className="request-table data-table internal-data-table">
                        <HeaderFilter enableDropdown={true} dropdownItem={dropdownItem} btnAddTitle={Header_Filter_Button_Label.AddAccount} enableExportExcel={false} enableAddBtn={true} enableUploadBtn={false} listItem={listItem} haveTab={false} />
                        {dataTable.map((item, id) =>
                            <DataTable key={id} id={id} item={item} header={item.HeaderItem} data={item.dataItem} getData={this.getData} customClassName="table-container" pages={pages} isDataLoaded={true} havePagination={false} />
                        )}
                    </div>
                }               
            </>
        )
    }
}